<template lang="pug">
  div.triggers-integrations
    .row.description
      .col-md-12
        label 
          strong {{ $t('integrations.title.trigger_stages') }}:
    .row
      .col-md-8.left(v-if="showIntegrationOnCreated()")
        .checkbox-inline.on-created(@click="toggleMark()")
          input(type='checkbox', name="created" :checked='on_created')
          label {{ $t('integrations.checkbox.trigger_stages.onCreated') }}
    .row      
      .col-md-8.left
        .checkbox-inline.on-created(@click='toggleStatusTrigger()')
          input(type='checkbox', name='status_connected_trigger', :checked='status_connected_trigger')
          label {{ $t('integrations.checkbox.trigger_stages.onStatusConnected') }}
    .row
      .col-md-6.left
        .checkbox-inline.on-created(@click='toggleTrigger()')
          input(type='checkbox',
                name='trigger',
                :checked='trigger')
          label {{ $t('integrations.checkbox.trigger_stages.onAdvanceStage') }}:
  
      .col-md-6(v-if="trigger")
        stages-select(@item-selected-items='itemSelectedItems',
                      :integration="integration"
                      :filter_item_selected_ids='filter_item_selected_ids')
    .row(v-if="integration == 'webhook'")
      .col-md-8.left
        .checkbox-inline.on-created(@click='toggleResponsibilityTrigger()')
          input(type='checkbox', name='change_responsibility_trigger',
                :checked='on_change')
          label {{ $t('integrations.checkbox.trigger_stages.onChangeResponsibility') }}

</template>

<script>
const helpers = require('../../../helpers.coffee')

let view_model = {
  props: ['settings', 'integration','on_responsibility'],

  components: {
    stagesSelect: require('../../shared/dropdown_multiple_kind/stage_filter.vue')
  },

  data () {
    return {
      kind_multiple_filter: 'stage_filter',
      uncheck_all_items: false,
      filter_item_selected_ids: [],
      trigger: false,
      stage_created: null,
      triggers: { status: [], stages: [] },
      status_connected_trigger: true,
      stages: [],
      on_created: false,
      on_change: false
    }
  },

  methods: {
    showIntegrationOnCreated() {
      return ['hubspot', 'pipedrive', 'nectar', 'webhook', 'vtiger'].indexOf(this.integration) > -1
    },

    toggleTrigger(trigger) {
      this.trigger = !this.trigger
      if(!this.trigger) {
        this.itemSelectedItems([])
      }
    },

    toggleStatusTrigger() {
      this.status_connected_trigger = !this.status_connected_trigger
      this.emitData();
    },

    itemSelectedItems(data) {
      this.stages = data
      this.emitData();
    },

    emitData() {
      this.triggers = {
        status: [],
        stages: this.stages,
        on_change: this.on_change,
        on_created: this.on_created
        
      }
      if(this.status_connected_trigger) {
        this.triggers.status.push('connected')
      }
      this.$emit('selected-stages', this.triggers)
    },

    toggleResponsibilityTrigger(){
      this.on_change = !this.on_change
      this.emitData();
    },

    toggleMark() {
      this.on_created = !this.on_created
      this.emitData();
    }
  },

  watch: {
    settings() {
      this.on_created = this.settings.on_created
      this.triggers = { stages: [ this.settings.stages ], status: [ this.settings.status ] }
      if(this.settings.status)
        this.status_connected_trigger = this.settings.status.indexOf('connected') > -1
      if(this.settings.stages)
        this.filter_item_selected_ids = this.settings.stages
      if(this.filter_item_selected_ids.length > 0) {
        this.trigger = true
      }
    }
  },

  created() {
    if(!this.settings || this.settings == {}) {
      this.itemSelectedItems([])
      return
    }
    if(this.settings.status)
      this.status_connected_trigger = this.settings.status.indexOf('connected') > -1
    if(this.settings.stages)
      this.filter_item_selected_ids = this.settings.stages
    if(this.filter_item_selected_ids.length > 0) {
      this.trigger = true
    }
    
    this.stages = this.settings.stages
    this.on_created = this.settings.on_created
    this.on_change = this.on_responsibility
  }
}

exports.default = helpers.vue_include(view_model, helpers.form)
</script>

<style lang="sass" scoped>

@import '../../../assets/stylesheets/_variables.sass'

.triggers-integrations
  padding-bottom: 10px

.description
  padding: 5px 20px 0px 0px
  text-align: left

.left
  padding-left: 0px
  padding-right: 0px

.leftadd
  padding-left: 0px
  padding-right: 0px
  float:left

.toggler-inline
  padding: 7px 0 0 15px
  text-align: left

.on-created
  float: left
  padding: 12px

.indice
    float: none
    color: $dark-slate-gray
    font-size: .9em
    text-align: left
    margin-bottom: 25px
    &.indice-plus
      margin-top: 15px
</style>



// WEBPACK FOOTER //
// trigger_stages.vue?59fc86ae